var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('render-label-value',{attrs:{"value":_vm.translatedRole,"tagClass":("it-tag " + _vm.roleColor)}})}
var staticRenderFns = []

export { render, staticRenderFns }